// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"859daff4","732":"142b4d2e","977":"fea8ffe0"}[chunkId] + ".chunk.js";
};